// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"f0c4ad7e","82":"0db60f1e","247":"13dc1a35","288":"82517266","488":"80dfe7cd","627":"6e97d686","653":"4512614e","768":"169b7f4e","834":"08721e32","867":"0058bfe8","923":"88f9252f","938":"287cf193"}[chunkId] + ".chunk.js";
};